// Join.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaGlassCheers, FaImages } from 'react-icons/fa';
import './Join.css';
import chicagoImage from '../../images/wedding/join.jpg';

const Join = () => {
    const { t } = useTranslation();

    return (
        <section className="join-section" style={{ backgroundImage: `url(${chicagoImage})` }}>
            <div className="join-overlay">
                <div className="join-content">
                    <p className="join-message"><FaGlassCheers className="icon" /> {t('join.message')}</p>
                    <p className="join-deadline"><FaImages className="icon" /> {t('join.deadline')}</p>
                    {/* The wedding has happened: this used to send guests to an
                        RSVP form with a March 2025 deadline. It now points at
                        the thing they actually want — the photos of the day. */}
                    <Link to="/photos" className="rsvp-button">
                        {t('join.rsvpButton')}
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default Join;